// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f059da92","488":"1ef263c7"}[chunkId] + ".chunk.js";
};